import { IPhoneForm } from '~/src/components/LandingBlock/Header/CallbackForm/types';
import { TAnalytics } from '~/src/services/blocks/configs/Part/analyticsPartConfig';
import CallbackForm from '~/src/components/LandingBlock/Header/CallbackForm';
import { ICityData } from '~/src/components/LandingBlock/Header/HeaderPanel';
import { getTextWithTag } from '~/src/helpers/getTextWithTag';
import * as ST from './styled';
import { useMemo } from 'react';

export interface ICallbackBlockProps {
    blockId: string,
    title: string;
    subtitle?: string;
    isAdmin: boolean;
    form?: IPhoneForm;
    analytics?: TAnalytics;
    progress?: string[];
    customStyles?: ST.ICallbackBlockStyles;
    cityData: ICityData;
    background?: string;
    alias?: string;
    additionalBlockConfig?: any;
    titleTag?: string;
    subtitleTag?: string;
}

const CallbackBlock = ({
    blockId,
    title,
    subtitle,
    isAdmin,
    form,
    analytics,
    progress,
    customStyles,
    cityData,
    background,
    alias,
    additionalBlockConfig,
    titleTag,
    subtitleTag,
}: ICallbackBlockProps): JSX.Element => {
    const phone = useMemo(() => {
        if (cityData) {
            const { city } = cityData;
            return `+7 (${city?.phone_code}) ${city?.sale_phone}`;
        }
        return '';
    }, [cityData]);

    const titleWithTag = getTextWithTag(title, titleTag);
    const subtitleWithTag = getTextWithTag(subtitle, subtitleTag);

    return (
        <ST.Wrapper id={blockId} {...customStyles} background={background} {...additionalBlockConfig}>
            <ST.Grid modeName='wide'>
                <ST.BorderWrapper>
                    <ST.Title {...customStyles} dangerouslySetInnerHTML={{ __html: titleWithTag }} />
                    <ST.Text {...customStyles} dangerouslySetInnerHTML={{ __html: subtitleWithTag }} />
                    {form && (
                        <CallbackForm
                            form={form}
                            isAdmin={isAdmin}
                            analytics={analytics}
                            gaLabel='bottom'
                            pageAlias={alias}
                            customStyles={customStyles}
                            inline
                        />
                    )}
                    <ST.Ol>
                        <ST.Row>
                            {progress.map((item, index) => (
                                <ST.Col md={4} xs={12} key={index}>
                                    <ST.Item dangerouslySetInnerHTML={{ __html: item }} {...customStyles}/>
                                </ST.Col>
                            ))}
                        </ST.Row>
                    </ST.Ol>
                    <ST.Phone center='xs' {...customStyles}>
                        <ST.PhoneLabel>Подключение:</ST.PhoneLabel>
                        <ST.PhoneLink
                            href={`tel:+${phone?.replace(/\D/g, '')}`}
                            className='js-calltouch-phone'
                        >
                            {phone}
                        </ST.PhoneLink>
                    </ST.Phone>
                </ST.BorderWrapper>
            </ST.Grid>
        </ST.Wrapper>
    );
};

export default CallbackBlock;
